const ENV = process.env.REACT_APP_ENV;

export const getFipId = (sitId, uatId) => {
  return ENV === "UAT" ? uatId : sitId;
};